import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import { useParentUsersUIContext } from "../ParentUsersUIContext";

const prepareFilter = (queryParams, values) => {
  let { tcKimlikNo, name, surname, studentName, sectionId, userGroupId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, studentName, sectionId, userGroupId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function ParentUsersFilter() {
  // Parent Users UI Context
  const parentUsersUIContext = useParentUsersUIContext();
  const parentUsersUIProps = useMemo(() => {
    return {
      setQueryParams: parentUsersUIContext.setQueryParams,
      queryParams: parentUsersUIContext.queryParams,
    };
  }, [parentUsersUIContext]);

  const dispatch = useDispatch();
  const { sections, userGroups } = useSelector(
    (state) => ({
      sections: state.userAssignment.filters,
      userGroups: state.userAssignment.userGroups
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getSections());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(parentUsersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, parentUsersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      parentUsersUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const sectionOptions = FilterOptions.concat(sections);
  const userGroupOptions = FilterOptions.concat(userGroups);

  return (
    <Formik
      initialValues={{
        tcKimlikNo: "",
        name: "",
        surname: "",
        studentName: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Öğrenci"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Şube"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={userGroupOptions}
                value={values.userGroupId}
                placeholder="Kullanıcı Grubu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("userGroupId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kullanıcı Grubu</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}